<template lang="pug">
section#start-calendar
  section.banner-area.relative
    .overlay.overlay-bg
    .container
      .row.fullscreen.align-items-center.justify-content-between
        .col-lg-6.col-md-7
          .banner-content
            h1(v-html="$t('startCalendar.title')")
            p(v-html="$t('startCalendar.subtitle')")
            button(v-on:click.prevent="getCalendar", v-bind:class="{'primary-btn': events.length === 0, 'genric-btn link': events.length > 0, disabled: !apiLoaded}")
              | {{ selectLabel }}
              loader(v-show="loading")
              span(v-show="events.length === 0 && !loading").lnr.lnr-calendar-full
            button.primary-btn.next-btn(v-on:click.prevent="nextStep", v-show="events.length && !loading")
              | {{ $t('controls.next') }}
              span.lnr.lnr-arrow-right
        .rpanel.col-lg-6.col-md-5
          .overlay.overlay-bg
            .counter
              p.step {{ $t('controls.step') }}
              p
                span.current 4
                span /4
              p.comment {{ $t('startCalendar.almost') }}
      .row
        .col
          router-link.genric-btn.circle.link(to="/start/location")
            span.lnr.lnr-arrow-left
            | &nbsp;
            | {{ $t('controls.back') }}
        .col.text-right
          router-link.skip-btn.genric-btn.circle.link(to="/dashboard")
            | {{ $t('controls.skip') }}
            | &nbsp;
            span.lnr.lnr-arrow-right

  section.next-area.relative
    .overlay.overlay-bg
    .container
      .row
        .col-md-10.offset-md-1
          p.next-title {{ $t('controls.next') }}: {{ $t('startCalendar.next') }}
</template>

<script>
import Project from '@/constants';
import saveState from 'vue-save-state';

import Loader from '@/components/partials/Loader';

export default {
  name: 'StartCalendar',
  components: {
    loader: Loader,
  },
  mixins: [saveState],
  data() {
    return {
      apiLoaded: false,
      events: [],
      loading: false,
    };
  },
  computed: {
    selectLabel() {
      if (this.loading) return '';
      if (!this.events.length) return this.$t('startCalendar.authorize');
      return this.$t('startCalendar.events', { n: this.events.length });
    },
  },
  metaInfo() {
    return {
      title: this.$t('startCalendar.meta.title'),
    };
  },
  methods: {
    getSaveStateConfig() {
      return {
        cacheKey: 'start.calendar',
        saveProperties: ['events'],
      };
    },
    onApiLoad() {
      window.gapi.load('client:auth2', this.initClient);
    },
    initClient() {
      window.gapi.client.init({
        apiKey: Project.google.picker.developerKey,
        clientId: Project.google.picker.clientId,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
        scope: 'https://www.googleapis.com/auth/calendar.readonly',
      }).then(() => {
        this.apiLoaded = true;
      });
    },
    getCalendar() {
      let colors = {};
      window.gapi.auth2.getAuthInstance().signIn().then(() => {
        this.loading = true;
        window.gapi.client.calendar.colors.get()
          .then((response) => {
            colors = JSON.parse(response.body).calendar;
          });
        window.gapi.client.calendar.events.list({
          calendarId: 'primary',
          timeMin: (new Date(this.$store.firstDate)).toISOString(),
          timeMax: (new Date(this.$store.lastDate)).toISOString(),
          showDeleted: false,
          singleEvents: true,
          orderBy: 'startTime',
        }).then((response) => {
          this.events = response.result.items.map((event) => {
            const e = event;
            e.color = colors[event.colorId];
            return e;
          });
          this.loading = false;
        })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    nextStep() {
      this.$store.sugarData.getCollection('events').clear();
      this.$store.sugarData.getCollection('events').insert(this.events);
      this.$router.push('/dashboard');
    },
  },
  mounted() {
    this.onApiLoad();
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'

#start-calendar
  overflow hidden
  background white

  p.info
    font-variant small-caps
    text-transform uppercase
    font-size .9em
    margin-top 10px
    margin-left 0px

  .next-btn
    margin-left 15px

.next-area
  background color-main
  padding base-padding * 2
  background url(/static/img/hypnotize.png) repeat
  .overlay-bg
    padding base-padding
    background rgba(color-main, .8)
  p
    color white
    font-size 2.5em
    font-weight 200
    text-align center
    font-variant small-caps
    text-transform lowercase
    letter-spacing 0.2em
    line-height 1em

.banner-area
  padding-bottom base-padding
  .banner-content
    padding-right base-padding

  .loader
    position relative
    top 4px
  //border-bottom 1px solid rgba(color-base, .25)

.rpanel
  background url(/static/img/event.jpg) no-repeat center/cover
  //width 50%
  height 100%
  top 0px
  right 0
  position absolute

  .overlay-bg
    background rgba(226, 109, 92, 0.8)
    display flex
    align-items center
    text-align center

  .counter
    margin auto
    color white
    font-size 15em
    span:not(.current)
      font-weight 200
      opacity .75
    .step
    .comment
      font-size 0.2em
      font-weight 200
      font-variant small-caps
      text-transform lowercase
      letter-spacing 0.3em
      position relative
      top -120px
    .comment
      top auto
      bottom -100px
      font-size 0.1em
    .current
      font-weight 900

@media (max-width: size-sm)
  .rpanel
    display none
    visibility hidden
</style>



// WEBPACK FOOTER //
// src/components/pages/Start.Calendar.vue